import React from "react";
import HeroSection from "./components/HeroSection";
import ServiceCategories from "./components/ServiceCategories";
import PopularCompanies from "./components/PopularCompanies";
import PromotionSection from "./components/PromotionSection";
import FAQ from "./components/FAQ";
import Footer from "../../components/Footer";

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <ServiceCategories />
      <PopularCompanies />
      <PromotionSection />
      <FAQ />
      <Footer />
    </div>
  );
};

export default HomePage;
